export default __webpack_public_path__ + "static/about-decor-2-593b8263f56db79e22ac1919ff8e99f3.png";